module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-arrow-up-fill-ea579a95.svg";